import { render, staticRenderFns } from "./LawMatterBudgetReportForm.vue?vue&type=template&id=22346ca2&"
import script from "./LawMatterBudgetReportForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterBudgetReportForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterBudgetReportForm.vue?vue&type=style&index=0&id=22346ca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports